(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion-classic"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__accordionClassicBound) return;
    window.__accordionClassicBound = true;

    document.addEventListener(
      'toggle',
      function (event) {
        var item = event.target;
        if (!(item instanceof HTMLDetailsElement)) return;
        if (!item.classList.contains('accordion-classic__item')) return;
        if (!item.open) return;

        var root = item.closest('[data-accordion-classic]');
        if (!root || root.getAttribute('data-open-mode') !== 'single') return;

        root.querySelectorAll('details.accordion-classic__item').forEach(function (other) {
          if (other !== item) other.open = false;
        });
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accordion-compact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__accordionCompactBound) return;
    window.__accordionCompactBound = true;

    var desktopQuery = window.matchMedia('(min-width: 768px)');

    function setExpanded(root, expanded) {
      root.classList.toggle('is-expanded', expanded);
      var toggle = root.querySelector('[data-accordion-compact-toggle]');
      if (toggle) {
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        toggle.setAttribute('aria-label', expanded ? 'Hide questions' : 'Show questions');
      }
      if (!expanded) {
        root.querySelectorAll('details.accordion-compact__item').forEach(function (item) {
          item.open = false;
        });
      }
    }

    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-accordion-compact-toggle]');
      if (!toggle) return;
      var root = toggle.closest('[data-accordion-compact]');
      if (!root) return;
      setExpanded(root, !root.classList.contains('is-expanded'));
    });

    document.addEventListener(
      'toggle',
      function (event) {
        var item = event.target;
        if (!(item instanceof HTMLDetailsElement)) return;
        if (!item.classList.contains('accordion-compact__item')) return;
        if (!item.open) return;

        var root = item.closest('[data-accordion-compact]');
        if (!root) return;

        root.querySelectorAll('details.accordion-compact__item').forEach(function (other) {
          if (other !== item) other.open = false;
        });
      },
      true
    );

    document.addEventListener('shopify:block:select', function (event) {
      var item = event.target.closest('.accordion-compact__item');
      if (!item) return;
      var root = item.closest('[data-accordion-compact]');
      if (!root) return;
      setExpanded(root, true);
      item.open = true;
    });

    document.addEventListener('shopify:section:select', function (event) {
      var root = event.target.querySelector('[data-accordion-compact]');
      if (!root) return;
      if (!desktopQuery.matches) setExpanded(root, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__jscReviewReadMoreBound) return;
    window.__jscReviewReadMoreBound = true;

    function initReviewReadMore(root) {
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('[data-jsc-review-holder]').forEach(function (holder) {
        if (holder.dataset.jscReviewReady === 'true') return;
        holder.dataset.jscReviewReady = 'true';

        var content = holder.querySelector('[data-jsc-review-content]');
        var actions = holder.querySelector('[data-jsc-review-actions]');
        var btn = holder.querySelector('[data-jsc-review-btn]');
        if (!content || !actions || !btn) return;

        function checkOverflow() {
          if (holder.classList.contains('jsc-expanded')) {
            actions.hidden = true;
            return;
          }
          actions.hidden = !(content.scrollHeight > content.clientHeight + 1);
        }

        btn.addEventListener('click', function () {
          holder.classList.add('jsc-expanded');
          actions.hidden = true;
        });

        checkOverflow();
        window.addEventListener('resize', checkOverflow);
      });
    }

    function onReady(fn) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fn);
      } else {
        fn();
      }
    }

    onReady(function () {
      initReviewReadMore(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
      initReviewReadMore(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["steps-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__jscExcHowBound) return;
    window.__jscExcHowBound = true;

    function activateTab(root, tab) {
      if (!root || !tab) return;
      var target = tab.getAttribute('aria-controls');
      var tabs = root.querySelectorAll('[data-jsc-exc-how-tab]');
      var panels = root.querySelectorAll('[role="tabpanel"]');

      tabs.forEach(function (item) {
        var selected = item === tab;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
        item.setAttribute('tabindex', selected ? '0' : '-1');
      });

      panels.forEach(function (panel) {
        var match = panel.id === target;
        panel.hidden = !match;
        panel.classList.toggle('is-active', match);
      });

      if (typeof tab.scrollIntoView === 'function') {
        tab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    }

    document.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-jsc-exc-how-tab]');
      if (!tab) return;
      var root = tab.closest('[data-jsc-exc-how]');
      if (!root) return;
      activateTab(root, tab);
    });

    document.addEventListener('keydown', function (event) {
      var tab = event.target.closest('[data-jsc-exc-how-tab]');
      if (!tab) return;
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      var root = tab.closest('[data-jsc-exc-how]');
      if (!root) return;
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-jsc-exc-how-tab]'));
      var index = tabs.indexOf(tab);
      var next = event.key === 'ArrowRight'
        ? tabs[index + 1] || tabs[0]
        : tabs[index - 1] || tabs[tabs.length - 1];
      next.focus();
      activateTab(root, next);
      event.preventDefault();
    });

    document.addEventListener('shopify:block:select', function (event) {
      var panel = event.target.closest('[role="tabpanel"]');
      if (!panel) return;
      var root = panel.closest('[data-jsc-exc-how]');
      if (!root) return;
      var tab = root.querySelector('[aria-controls="' + panel.id + '"]');
      if (tab) activateTab(root, tab);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
